import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiTrash2, FiPlus, FiLogOut } from 'react-icons/fi';

export default function AdminBlog() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [loginError, setLoginError] = useState('');

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);

  // Form State
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    dated: new Date().toISOString().split('T')[0],
    description: '',
    is_published: 1,
    is_featured: 0
  });
  const [imageFile, setImageFile] = useState(null);

  const API_URL = '/api/blogs';
  const getAuthHeader = () => ({
    'Authorization': `Basic ${username}:${password}`
  });

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === 'asrm' && password === 'asrm@2026') {
      setIsAuthenticated(true);
      fetchBlogs();
    } else {
      setLoginError('Invalid username or password');
    }
  };

  const fetchBlogs = () => {
    setLoading(true);
    fetch(API_URL, { headers: getAuthHeader() })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setBlogs(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImageFile(e.target.files[0]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const form = new FormData();
    form.append('title', formData.title);
    form.append('dated', formData.dated);
    form.append('description', formData.description);
    form.append('is_published', formData.is_published);
    form.append('is_featured', formData.is_featured);
    if (imageFile) {
      form.append('image', imageFile);
    }

    fetch(API_URL, {
      method: 'POST',
      headers: getAuthHeader(),
      body: form
    })
      .then(async (res) => {
        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.error || 'Failed to publish blog');
        }
        return res.json();
      })
      .then(() => {
        setIsEditing(false);
        setFormData({ title: '', dated: new Date().toISOString().split('T')[0], description: '', is_published: 1, is_featured: 0 });
        setImageFile(null);
        fetchBlogs();
      })
      .catch(err => {
        console.error(err);
        alert(err.message);
      });
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this blog?')) {
      fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: getAuthHeader()
      })
      .then(() => fetchBlogs());
    }
  };

  const toggleFeatured = (id) => {
    // Optimistic update
    setBlogs(blogs.map(b => b.id === id ? { ...b, is_featured: b.is_featured ? 0 : 1 } : b));
    fetch(`${API_URL}/${id}/toggle-featured`, {
      method: 'PATCH',
      headers: getAuthHeader()
    });
  };

  if (!isAuthenticated) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f8f9fa' }}>
        <form onSubmit={handleLogin} style={{ background: '#fff', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 16px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' }}>
          <h2 style={{ textAlign: 'center', marginBottom: '24px', color: '#198754' }}>Admin Login</h2>
          {loginError && <p style={{ color: 'red', textAlign: 'center', fontSize: '0.9rem' }}>{loginError}</p>}
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Username</label>
            <input 
              type="text" 
              value={username} 
              onChange={e => setUsername(e.target.value)} 
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #dee2e6' }} 
              required
            />
          </div>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Password</label>
            <input 
              type="password" 
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #dee2e6' }} 
              required
            />
          </div>
          <button type="submit" className="btn-primary" style={{ width: '100%', justifyContent: 'center', border: 'none', padding: '12px', borderRadius: '6px', cursor: 'pointer' }}>Login</button>
        </form>
      </div>
    );
  }

  return (
    <div className="admin-layout" style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f1f3f7' }}>
      {/* Sidebar */}
      <div className="admin-sidebar" style={{ width: '250px', background: '#2d3446', color: '#fff', padding: '24px', display: 'flex', flexDirection: 'column' }}>
        <h2 className="admin-brand" style={{ fontSize: '1.2rem', marginBottom: '40px', color: '#20c997' }}>ASRM Admin</h2>
        <div className="admin-nav-links" style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <button 
            onClick={() => setIsEditing(false)} 
            style={{ background: 'none', border: 'none', color: '#fff', textAlign: 'left', padding: '12px 0', fontSize: '1rem', cursor: 'pointer', borderBottom: '1px solid #4a5568' }}>
            Dashboard
          </button>
          <div style={{ marginTop: 'auto', paddingTop: '12px' }}>
            <button 
              onClick={() => navigate('/')} 
              style={{ background: 'none', border: 'none', color: '#fb7185', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '1rem' }}>
              <FiLogOut /> Logout
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="admin-main" style={{ flex: 1, padding: '40px', overflowY: 'auto', maxWidth: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
          <h1 style={{ fontSize: '2rem', color: '#1a1a1a' }}>{isEditing ? 'Create New Blog' : 'Blog Posts'}</h1>
          {!isEditing && (
            <button 
              onClick={() => setIsEditing(true)} 
              className="btn-primary" 
              style={{ border: 'none', padding: '10px 20px', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <FiPlus /> New Post
            </button>
          )}
        </div>

        {isEditing ? (
          <form onSubmit={handleSubmit} style={{ background: '#fff', padding: '32px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Title</label>
              <input required type="text" value={formData.title} onChange={e => setFormData({...formData, title: e.target.value})} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #dee2e6' }} />
            </div>
            
            <div className="admin-form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Date</label>
                <input required type="date" value={formData.dated} onChange={e => setFormData({...formData, dated: e.target.value})} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #dee2e6' }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Image Attachment (Optional)</label>
                <input type="file" accept="image/*" onChange={handleFileChange} style={{ width: '100%', padding: '7px', borderRadius: '6px', border: '1px solid #dee2e6' }} />
              </div>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Description / Content</label>
              <textarea required rows="10" value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #dee2e6', resize: 'vertical' }}></textarea>
            </div>

            <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input type="checkbox" id="is_featured" checked={formData.is_featured === 1} onChange={e => setFormData({...formData, is_featured: e.target.checked ? 1 : 0})} style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
              <label htmlFor="is_featured" style={{ fontWeight: 'bold', cursor: 'pointer' }}>Mark as Featured Blog</label>
            </div>

            <div style={{ display: 'flex', gap: '16px' }}>
              <button type="submit" className="btn-primary" style={{ border: 'none', padding: '12px 24px', borderRadius: '6px', cursor: 'pointer' }}>Publish Blog</button>
              <button type="button" onClick={() => setIsEditing(false)} style={{ background: '#f8f9fa', border: '1px solid #dee2e6', padding: '12px 24px', borderRadius: '6px', cursor: 'pointer' }}>Cancel</button>
            </div>
          </form>
        ) : (
          <div className="admin-table-wrapper" style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflowX: 'auto' }}>
            <table className="admin-table" style={{ width: '100%', borderCollapse: 'collapse', minWidth: '650px' }}>
              <thead style={{ background: '#f8f9fa', textAlign: 'left' }}>
                <tr>
                  <th style={{ padding: '16px 24px', borderBottom: '1px solid #dee2e6' }}>Title</th>
                  <th style={{ padding: '16px 24px', borderBottom: '1px solid #dee2e6' }}>Date</th>
                  <th style={{ padding: '16px 24px', borderBottom: '1px solid #dee2e6' }}>Featured</th>
                  <th style={{ padding: '16px 24px', borderBottom: '1px solid #dee2e6' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="4" style={{ padding: '24px', textAlign: 'center' }}>Loading...</td></tr>
                ) : blogs.length === 0 ? (
                  <tr><td colSpan="4" style={{ padding: '24px', textAlign: 'center', color: '#6c757d' }}>No blogs found. Create one!</td></tr>
                ) : (
                  blogs.map(blog => (
                    <tr key={blog.id} style={{ borderBottom: '1px solid #f1f3f7' }}>
                      <td style={{ padding: '16px 24px' }}>{blog.title}</td>
                      <td style={{ padding: '16px 24px', color: '#6c757d', whiteSpace: 'nowrap' }}>
                        {blog.dated ? blog.dated.split('-').reverse().join('-') : ''}
                      </td>
                      <td style={{ padding: '16px 24px' }}>
                        <div 
                          onClick={() => toggleFeatured(blog.id)}
                          style={{
                            width: '40px',
                            height: '20px',
                            background: blog.is_featured ? 'var(--primary)' : '#e2e8f0',
                            borderRadius: '10px',
                            position: 'relative',
                            cursor: 'pointer',
                            transition: 'background 0.3s ease'
                          }}
                        >
                          <div style={{
                            width: '16px',
                            height: '16px',
                            background: '#fff',
                            borderRadius: '50%',
                            position: 'absolute',
                            top: '2px',
                            left: blog.is_featured ? '22px' : '2px',
                            transition: 'left 0.3s ease',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                          }} />
                        </div>
                      </td>
                      <td style={{ padding: '16px 24px' }}>
                        <button onClick={() => handleDelete(blog.id)} style={{ background: 'none', border: 'none', color: '#fb7185', cursor: 'pointer' }}>
                          <FiTrash2 size={18} />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
